export default __webpack_public_path__ + "static/media/picsRotating.33331b53.png";